import styled from 'styled-components';

import { media } from '~/src/styles-constants';

import { sectionStyle } from '../../utils';

export const Container = styled.section`
  ${sectionStyle({ margin: false })}
  padding: 32px 0;
  flex-direction: column;
  background-color: ${({ theme }) => theme.palette.common.PRIMARY};

  ${media.L`
    padding: 48px 48px 120px 48px;
  `}
`;

export const Title = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    height: 52px;
  }

  h2 {
    margin: 20px 0;
    font-family: ${({ theme }) => theme.fonts.secondary};
    font-size: 24px;
    color: ${({ theme }) => theme.palette.common.WHITE};
    font-weight: 700;
    line-height: 40px;
  }
`;

export const Scroller = styled.div`
  display: flex;
  overflow-x: scroll;

  /* Cache la scrollbar mais conserve le fonctionnement */
  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const Content = styled.div`
  display: flex;
  gap: 16px;
  padding-left: 16px;
  padding-right: 16px;
  margin-left: auto;
  margin-right: auto;
`;
